var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dictionary-setting-wrap"},[_c('vxe-grid',{ref:"grid",attrs:{"show-overflow":"title","data":_vm.tableData,"columns":_vm.tableColumn}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }